import { httpGet, httpDel, httpPut, httpPost } from '@/tool/request/index';

// 获取设备列表
export async function getDevicesBySysId(systemId: string) {
  return await httpGet<API.RootResponse>(
    `/iot/device/devices?systemId=${systemId}`
  )();
}

// 保存设备
export async function saveDeviceData(data) {
  return await httpPost<API.RootResponse>(`/iot/device/record/save`)({
    data: data,
  });
}

// 获取设置详情
export async function getDeviceDetailById(recordId) {
  return await httpGet<API.RootResponse>(`/iot/device/record/${recordId}`)();
}

// 获取设置详情（根据日报id）
export async function getDeviceDetailByReportId(reportId: string) {
  return await httpGet<API.RootResponse>(`/iot/device/report/${reportId}`)();
}

// 获取短信验证码
export async function deviceGenerateCode(params: any) {
  return await httpGet<API.RootResponse>(`/iot/device/device/generateCode`)({
    params:params,
  });
}

// 修改状态
export async function deviceDevice(
  deviceId: string,
  operatingState: boolean,
  smsCode: string
) {
  return await httpPut<API.RootResponse>(
    `/iot/device/device?deviceId=${deviceId}&operatingState=${operatingState}&smsCode=${smsCode}`
  )();
}
